import React from 'react';
import WebpackerReact from 'webpacker-react';

import App from '../containers/weployer/App';

const Portal = () => (
  <App />
);

WebpackerReact.setup({ App });

export default Portal;
